import { Ban, PlugZap } from "lucide-react";
import { useTranslation } from "react-i18next";

import { useAssistantProfile } from "../../hooks/useAssistantProfile";
import { chatAccessState, type ChatAccess } from "../../lib/chatAccess";

/** Chat access for the Hub: the state plus the companion's name. */
export function useChatAccess(): { access: ChatAccess; name: string } {
  const { data } = useAssistantProfile();
  return {
    access: chatAccessState(data?.resolved),
    name: data?.resolved?.assistant_name || "Mochi",
  };
}

/** Explains why the composer is switched off. Renders nothing when chat works. */
export function ChatAccessNotice({ access, name }: { access: ChatAccess; name: string }) {
  const { t } = useTranslation();
  if (access === "ok") return null;
  const Icon = access === "disabled" ? Ban : PlugZap;
  const text =
    access === "disabled"
      ? t("assistant.hub.chatDisabled", {
          defaultValue: "Chat with {{name}} is turned off for your organization. An admin can turn it back on in the assistant settings.",
          name,
        })
      : t("assistant.hub.notConfigured", {
          defaultValue: "{{name}} can’t talk yet — an admin needs to add an AI provider key to the server.",
          name,
        });
  return (
    <div
      role="status"
      className="mx-auto mb-3 flex w-full max-w-3xl items-start gap-2 rounded-xl border border-border bg-muted/60 px-4 py-3 text-sm text-foreground"
    >
      <Icon className="mt-0.5 size-4 shrink-0 text-muted-foreground" aria-hidden />
      <p dir="auto">{text}</p>
    </div>
  );
}
